var React = require('react');

function CouponCheck (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 9.25V7.75M10 16.25V14.75M10 12.75V11.25M21.5 14.5V18H11.5C11.5 17.1716 10.8284 16.5 10 16.5C9.17157 16.5 8.5 17.1716 8.5 18H2.5V6H8.5C8.5 6.82843 9.17157 7.5 10 7.5C10.8284 7.5 11.5 6.82843 11.5 6H21.5V7","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M16 12L18 14L23 9","stroke":"#0088BF","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CouponCheck.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CouponCheck;

CouponCheck.default = CouponCheck;
